import { yupResolver } from "@hookform/resolvers/yup";
import { notification } from "antd";
import { pick } from "lodash-es";
import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { useIntl } from "react-intl";

import { AgentAPI } from "@/api";
import { AgentUpdated } from "@/events";
import Query from "@/models/query";
import { useGlobalStore } from "@/stores";

import { Props } from "./GeneralForm";
import { ISchema, useSchema } from "./schema";

export function useGeneralFormState({ agent }: Props) {
  const intl = useIntl();

  const schema = useSchema();
  const form = useForm<ISchema>({
    resolver: yupResolver(schema),
  });

  const { eventBusService } = useGlobalStore();

  const loadQuery = useMemo(() => {
    const query = new Query(AgentAPI.getById);
    query.submit({ id: agent.id }).then(() => {
      const updatedAgent = query.data!;
      form.reset(
        pick(updatedAgent, [
          "isConvActive",
          "isBalanceUnlimited",
          "isBlocked",
          "canHaveChildren",
          "configuredByParent",
          "kycType",
          "gameDisplayType",
          "hideParamsIfConfiguredByParent",
        ]),
      );
    });
    return query;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submitQuery = useMemo(() => {
    return new Query(async (values: ISchema) => {
      await AgentAPI.update({ id: agent.id, ...values });

      eventBusService.publish(new AgentUpdated({ agentId: agent.id }));

      notification.success({
        message: "",
        description: intl.formatMessage({
          defaultMessage: "The agent has been successfully updated.",
        }),
      });
    });
  }, [eventBusService, intl, agent]);

  return { submitQuery, form, loadQuery };
}
